var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { forwardRef } from 'react';
import { jsx as createElement } from 'theme-ui';
import { omit, pick } from 'lodash';
import { useThemeStyle, getThemeKeyNames } from '../hooks/useThemeStyle';
export function createThemedComponent(themeProps, defaultProps, options) {
    if (options === void 0) { options = {}; }
    return forwardRef(function (props, ref) {
        var resolvedDefaultProps = typeof defaultProps === 'function'
            ? defaultProps(props)
            : defaultProps;
        var _a = __assign(__assign(__assign({ as: 'div' }, resolvedDefaultProps), props), { ref: ref }), as = _a.as, themeKey = _a.themeKey, sx = _a.sx, mergedProps = __rest(_a, ["as", "themeKey", "sx"]);
        var css = useThemeStyle.apply(void 0, __spreadArray([sx], getThemeKeyNames(pick(mergedProps, themeProps), themeKey), false));
        return createElement(as, __assign(__assign({}, (options.includeThemeProps
            ? mergedProps
            : omit(mergedProps, themeProps))), { css: css }));
    });
}
export function createSimpleThemedComponent(defaultProps) {
    return createThemedComponent(['variant'], defaultProps);
}
//# sourceMappingURL=createThemedComponent.js.map